<template>
  <div>
    <a-row>
      <a-col
        :sm="{ span: 20, offset: 2 }"
        :md="{ span: 20, offset: 2 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <a-card
          style="
            width: 100%;
            line-height: 25px;
            text-align: justify;
            border-radius: 5px;
            border-color: black;
            border-width: 1.7px;
          "
        >
          <!-- <p style="color: black; font-size: 15px">
            Meanwhile, scPertrubDB is a comprehensive resource that integrates
            data from multiple studies that have used single-cell perturb-seq to
            infer gene function. The database includes information on gene-level
            and cell-level effects of perturbations, as well as information on
            the experimental conditions under which the perturbations were
            performed.
          </p> -->
          <!-- <p style="color: black; font-size: 15px">
            Using scPertrubDB, researchers can explore the effects of
            perturbations on specific genes in different cell types and under
            different conditions. They can also use the database to generate
            hypotheses about the function of previously uncharacterized genes.
          </p> -->
          <!-- <p style="color: black; font-size: 15px">
            Overall, scPertrubDB is a valuable resource for the single-cell
            genomics community, as it enables data-driven inference of gene
            function and supports the development of new hypotheses about gene
            function and cellular processes.
          </p> -->
          <a-card
            style="
              width: 100%;
              height: 100%;
              text-align: justify;
              border-radius: 5px;
              margin-top: 100px;
              border-color: transparent;
            "
          >
            <h2 class="h1" style="text-align: center; color: #33915b">
              Explore the functions of genes
            </h2>
            <br />
            <br />
            <!-- <a-input-search
              placeholder="Input a gene"
              style="width: 100%"
              v-model="quickValue"
              size="large"
              @search="onSearch"
            /> -->
            <a-select
              style="width: 100%"
              @search="handleSearch"
              @change="handleChange"
              show-search
              size="large"
              :filter-option="true"
              :value="value"
            >
              <a-select-option
                v-for="item in options"
                :key="item"
                :value="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
            <br />
            <br />
            <div style="text-align: center; margin-top: 22px">
              <span class="zistyle">Example</span> :
              <a @click="addQuickSearch('SIRT7')" style="color: blue"> SIRT7</a>
              <a-divider type="vertical"></a-divider>
              <a @click="addQuickSearch('IRF1')" style="color: blue">IRF1</a>
            </div>
            <br />
          </a-card>

          <p
            style="
              color: black;
              font-size: 15px;
              margin-top: 60px;
              padding: 10px 20px;
            "
          >
            <!-- <span style="font-size: 18px; font-weight: bolder"
              >scPerturbDB</span
            >
            is a database resource that provides data-driven inference of gene
            function based on single-cell perturb-seq data. Single-cell
            perturb-seq is a technique that enables researchers to perturb a
            single gene in individual cells and then measure the resulting
            changes in gene expression using RNA sequencing, which help
            researchers to infer gene function.  -->
          </p>
        </a-card></a-col
      >
    </a-row>
    <a-col
      style="margin-top: 10px"
      :sm="{ span: 20, offset: 2 }"
      :md="{ span: 20, offset: 2 }"
      :xl="{ span: 20, offset: 2 }"
    >
      <a-row :gutter="12">
        <a-col
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :xl="{ span: 6 }"
          style="margin-top: 5px"
          class="smooth-hover"
        >
          <a
            href="javascript::"
            @click="
              goSubpage(
                'http://research.gzsys.org.cn/perturbdb/#/publications?perturbstype=scRNA'
              )
            "
          >
            <a-card
              style="
                width: 100%;
                height: 310px;
                border-radius: 5px;
                border-color: black;
                border-width: 1.7px;
              "
              hoverable
            >
              <a-card-meta style="text-align: center">
                <template slot="title">
                  <span
                    style="font-size: 25px; color: black; font-weight: bolder"
                    >Perturb-Seq</span
                  >
                </template>
              </a-card-meta>
              <img
                style="margin-left: 2.1%"
                slot="cover"
                alt="example"
                height="250"
                width="20%"
                src="http://research.gzsys.org.cn/perturbdb/image/genes.png"
            /></a-card>
          </a>
        </a-col>
        <a-col
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :xl="{ span: 6 }"
          style="margin-top: 5px"
          class="smooth-hover"
        >
          <a
            href="javascript::"
            @click="
              goSubpage('http://research.gzsys.org.cn/perturbdb/#/fclusters')
            "
          >
            <a-card
              style="
                width: 100%;
                height: 310px;
                border-radius: 5px;
                border-color: black;
                border-width: 1.7px;
              "
              hoverable
            >
              <a-card-meta style="text-align: center">
                <template slot="title">
                  <span
                    style="font-size: 25px; color: black; font-weight: bolder"
                    >Perturbation clusters</span
                  >
                </template>
              </a-card-meta>

              <img
                style="margin-left: 10%"
                slot="cover"
                alt="example"
                height="250"
                src="http://research.gzsys.org.cn/perturbdb/image/clusters.png"
              /> </a-card
          ></a>
        </a-col>
        <a-col
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :xl="{ span: 6 }"
          style="margin-top: 5px"
          class="smooth-hover"
        >
          <a
            href="javascript::"
            @click="
              goSubpage('http://research.gzsys.org.cn/perturbdb/#/inhibitor')
            "
          >
            <a-card
              style="
                width: 100%;
                height: 310px;
                border-radius: 5px;
                border-color: black;
                border-width: 1.7px;
              "
              hoverable
            >
              <a-card-meta style="text-align: center">
                <template slot="title">
                  <span
                    style="font-size: 25px; color: black; font-weight: bolder"
                    >Inhibitors</span
                  >
                </template>
              </a-card-meta>
              <img
                slot="cover"
                alt="example"
                height="250"
                width="40%"
                style="padding-top: 15px"
                src="http://research.gzsys.org.cn/perturbdb/image/inhibitors.png"
            /></a-card>
          </a>
        </a-col>
        <a-col
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :xl="{ span: 6 }"
          style="margin-top: 5px"
          class="smooth-hover"
        >
          <a
            href="javascript::"
            @click="goSubpage('http://research.gzsys.org.cn/perturbdb/#/PGSEA')"
          >
            <a-card
              style=" hoverable
              width: 100%;
              height: 310px;
              border-radius: 5px;
              border-color: black;
              border-width: 1.7px;
            "
            >
              <a-card-meta style="text-align: center">
                <template slot="title">
                  <span
                    style="font-size: 25px; color: black; font-weight: bolder"
                    >PGSEA</span
                  >
                </template>
              </a-card-meta>
              <img
                slot="cover"
                alt="example"
                height="250"
                width="20%"
                src="http://research.gzsys.org.cn/perturbdb/image/PGSEA.png" /></a-card
          ></a>
        </a-col>
      </a-row>
    </a-col>
    <a-col
      style="margin-top: 10px"
      :sm="{ span: 20, offset: 2 }"
      :md="{ span: 20, offset: 2 }"
      :xl="{ span: 20, offset: 2 }"
    >
      <a-row :gutter="12">
        <a-col
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :xl="{ span: 8 }"
          style="margin-top: 5px"
        >
          <a-card
            style="
              width: 100%;
              height: 300px;
              overflow-y: auto;
              border-radius: 5px;
              border-color: black;
              border-width: 1.7px;
            "
          >
            <h1 style="font-size: 18px"><a-icon type="notification" /> News</h1>
            <a-timeline style="margin-top: 20px">
              <a-timeline-item color="green">
                <!-- <a-icontype="check" style="font-size: 16px" /> -->
                <a-icon
                  slot="dot"
                  type="smile"
                  style="font-size: 16px"
                  theme="twoTone"
                  two-tone-color="#eb2f96"
                />
                <div style="text-align: justify">
                  2025.01.20 We have added a new module: Cancer Hallmark , where
                  the scoring is based on the VISION algorithm and the inferCNV
                  algorithm.
                </div>
              </a-timeline-item>
              <a-timeline-item color="green">
                <div style="text-align: justify">
                  2024.09.11 The article on PerturbDB has been published online.
                  Please cite our work:
                  <a
                    href="https://doi.org/10.1093/nar/gkae777"
                    target="_blank"
                    style="color: blue"
                    >PerturbDB for unraveling gene functions and regulatory
                    networks</a
                  >
                  <span
                    onmouseover="this.style.cursor='pointer'"
                    @click="downloadFile()"
                    style="
                      font-weight: bolder;
                      color: black;
                      margin-left: 2px;
                      display: inline-block;
                    "
                  >
                    <a-tooltip title="Download now" placement="right">
                      <a-icon type="file-pdf" /> <span> PDF</span>
                    </a-tooltip> </span
                  ><span style="color: blue">.</span>
                </div>
              </a-timeline-item>
              <a-timeline-item color="green">
                <!-- <a-icontype="check" style="font-size: 16px" /> -->
                <!-- <a-icon
                  slot="dot"
                  type="smile"
                  style="font-size: 16px"
                  theme="twoTone"
                  two-tone-color="#eb2f96"
                /> -->
                <div style="text-align: justify">
                  2024.08.13 PerturbDB has been accepted by
                  <i style="color: blue">Nucleic Acids Research</i>.
                  <!-- <a
                    href="http://research.gzsys.org.cn/perturbdb/data/docs/PerturbDB_release_notes_v1.2.txt"
                    target="_blank"
                    style="font-weight: bolder; color: blue"
                    >release notes.</a
                  > -->
                </div>
              </a-timeline-item>
              <a-timeline-item color="green">
                <!-- <a-icon slot="dot" type="check" style="font-size: 16px" /> -->
                <div style="text-align: justify">
                  2024.07.25 PerturbDB updated to v1.2, see
                  <a
                    href="http://research.gzsys.org.cn/perturbdb/data/docs/PerturbDB_release_notes_v1.2.txt"
                    target="_blank"
                    style="font-weight: bolder; color: blue"
                    >release notes.</a
                  >
                </div>
              </a-timeline-item>
              <a-timeline-item color="green">
                <!-- <a-icon slot="dot" type="dot" style="font-size: 16px" /> -->
                <div style="text-align: justify">
                  2024.06.01 PerturbDB updated to v1.1, see
                  <a
                    href="http://research.gzsys.org.cn/perturbdb/data/docs/PerturbDB_release_notes_v1.1.txt"
                    target="_blank"
                    style="font-weight: bolder; color: blue"
                    >release notes.</a
                  >
                </div>
              </a-timeline-item>
              <a-timeline-item color="green">
                <!-- <a-icon slot="dot" type="check" style="font-size: 16px" /> -->
                2023.06.29 PerturbDB v1.0 is online
              </a-timeline-item>
            </a-timeline>
          </a-card></a-col
        >
        <a-col
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :xl="{ span: 8 }"
          style="margin-top: 5px"
        >
          <a-card
            style="
              text-align: justify;
              width: 100%;
              height: 300px;
              border-radius: 5px;
              border-color: black;
              border-width: 1.7px;
            "
          >
            <h1 style="font-size: 18px"><a-icon type="mail" /> Contact us</h1>
            <h4>
              PerturbDB is actively being enhanced. If you have any suggestions,
              please contact us:
            </h4>
            <a-list :split="false">
              <a-list-item>
                <a-list-item-meta description="yind3@mail.sysu.edu.cn">
                  <a slot="title" href="mailto:yind3@mail.sysu.edu.cn"
                    >Dong Yin</a
                  >
                  <a-avatar
                    slot="avatar"
                    src="http://research.gzsys.org.cn/perturbdb/image/boss.png"
                  />
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-list-item-meta description="liaojy3@mail.sysu.edu.cn">
                  <a slot="title" href="mailto:liaojy3@mail.sysu.edu.cn"
                    >Jian-You Liao</a
                  >
                  <a-avatar
                    slot="avatar"
                    src="http://research.gzsys.org.cn/perturbdb/image/liao.png"
                  />
                </a-list-item-meta>
              </a-list-item>
            </a-list> </a-card
        ></a-col>
        <a-col
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :xl="{ span: 8 }"
          style="margin-top: 5px"
        >
          <a-card
            style="
              width: 100%;
              height: 300px;
              overflow-y: auto;
              border-radius: 5px;
              border-color: black;
              border-width: 1.7px;
            "
          >
            <h1 style="font-size: 18px"><a-icon type="team" /> Map</h1>

            <div style="text-align: center">
              <!-- <a href="https://www.revolvermaps.com/livestats/5jsx7lz865h/"
                ><img
                  src="//rf.revolvermaps.com/h/m/a/0/ff0000/128/0/5jsx7lz865h.png"
                  width="340"
                  height="210"
                  alt="Map"
                  style="border: 0"
              /></a> -->
              <!-- <a href="https://www.revolvermaps.com/livestats/515vfbsird0/"
                ><img
                  src="//rf.revolvermaps.com/h/m/a/0/ff0000/128/0/515vfbsird0.png"
                  width="340"
                  height="210"
                  alt="Map"
                  style="border: 0"
              /></a> -->
              <a href="https://clustrmaps.com/site/1bzzo" title="Visit tracker"
                ><img
                  width="85%"
                  height="50%"
                  src="//www.clustrmaps.com/map_v2.png?d=tPrYDscrBzV5LakxRYzLffTmViCHrLbwl0gSJwE-FcI&cl=ffffff"
              /></a>
              <!-- <a href="https://clustrmaps.com/site/1bzzo" title="Visiters"
                ><img
                  src="//www.clustrmaps.com/map_v2.png?d=tPrYDscrBzV5LakxRYzLffTmViCHrLbwl0gSJwE-FcI&cl=ffffff"
                  width="100%"
                  height="100%"
              /></a> -->
            </div>
          </a-card></a-col
        >
        <a-col :span="24" style="margin-top: 10px"> </a-col>
      </a-row>
    </a-col>
    <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 20, offset: 2 }">
      <a-alert type="info" close-text="Close Now">
        <a slot="message">
          <a-icon type="exclamation-circle" /> For optimal user experience, it
          is recommended to use the latest version of Google Chrome or Safari
          browser.
        </a>
      </a-alert>
    </a-col>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      website: "http://research.gzsys.org.cn/perturbdb",
      quickValue: "",
      value: "",
      options: [],
    };
  },
  mounted() {
    axios
      .get(this.website + "/API/search/homoInput.php", {
        params: {
          gene: "A",
        },
      })
      .then((response) => {
        this.options = response.data.slice(0, 20);
      });
  },
  methods: {
    //下载文件
    downloadFile() {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");
      link.style.display = "none";

      // 设置文件的下载链接

      link.href =
        "http://research.gzsys.org.cn/perturbdb/data/docs/gkae777.pdf";

      link.setAttribute("download", "gkae777.pdf");

      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    //页面跳转:
    goSubpage(value) {
      window.open(value, "_blank");
    },
    addQuickSearch(value) {
      this.value = value;
      let routeData = this.$router.resolve({
        name: "quickSearch",
        query: { gene: value },
      });
      window.open(routeData.href, "_blank");
      this.value = "";
    },
    //搜索框
    handleChange(value) {
      this.value = value;
      let routeData = this.$router.resolve({
        name: "quickSearch",
        query: { gene: value },
      });
      window.open(routeData.href, "_blank");
      this.value = "";
    },
    handleSearch(value) {
      if (value == "") {
        axios
          .get(this.website + "/API/search/homoInput.php", {
            params: {
              gene: "A",
            },
          })
          .then((response) => {
            this.options = response.data.slice(0, 20);
          });
      } else {
        axios
          .get(this.website + "/API/search/homoInput.php", {
            params: {
              gene: value,
            },
          })
          .then((response) => {
            this.options = response.data.slice(0, 20);
          });
      }
    },
  },
};
</script>
<style scoped>
.margintop {
  margin-top: 10px;
  /* top 一律为5px */
}
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
/* For demo */
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 400px;
  line-height: 160px;
  background: white;
  overflow: hidden;
}
.ant-carousel >>> .slick-slide h3 {
  color: black;
}
.ant-carousel >>> .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: black;
  opacity: 0.3;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}
.zistyle {
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bolder;
  color: #555;
  line-height: 1.5px;
}
.smooth-hover {
  transition: transform 0.5s ease;
}

.smooth-hover:hover {
  transform: translateY(-10px);
}
</style>
